module.exports = __webpack_public_path__ + "img/FORD.b5d535a.jpg";